import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Contacta", -1)

import { computed, ref, watch } from "vue";
import { ContactForm } from "@/interfaces/Contacto";
import { sendEmailContacto } from "@/services/ContactoService";
import { useRouter } from "vue-router";
import ModalSuccess from "@/components/Commons/ModalSuccess.vue";
import ModalError from "@/components/Commons/ModalError.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactoView',
  setup(__props) {

const consulta = ref<ContactForm>({
  email: "",
  message: "",
});
const router = useRouter();
const showSuccessModal = ref<boolean>(false);
const showErrorModal = ref<boolean>(false);
const isSubmitting = ref<boolean>(false);

const rules = {
  required: (value: string) => !!value || "Este campo es obligatorio.",
  email: (value: string) =>
    /^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/.test(value) ||
    "Introduce un correo válido.",
};

const isFormValid = computed(() => {
  return (
    rules.email(consulta.value.email) === true &&
    rules.required(consulta.value.message) === true
  );
});

const submitForm = async () => {
  if (isFormValid.value) {
    isSubmitting.value = true;
    try {
      await sendEmailContacto(consulta.value);
      showSuccessModal.value = true;
    } catch (error) {
      showErrorModal.value = true;
    } finally {
      isSubmitting.value = false;
    }
  }
};

watch(showSuccessModal, (newValue) => {
  if (!newValue) {
    router.push("mis-partidas");
  }
});

watch(showSuccessModal, (newValue) => {
  if (newValue) {
    setTimeout(() => {
      showSuccessModal.value = false;
    }, 4000);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "login-form" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { justify: "center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_form, {
                        justify: "center",
                        class: "my-4 ga-5",
                        ref: "contactForm",
                        onSubmit: _withModifiers(submitForm, ["prevent"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: consulta.value.email,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((consulta.value.email) = $event)),
                                    label: "Correo Electrónico",
                                    required: "",
                                    type: "email",
                                    rules: [rules.required, rules.email]
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_textarea, {
                                    modelValue: consulta.value.message,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((consulta.value.message) = $event)),
                                    label: "Mensaje",
                                    required: "",
                                    type: "text",
                                    rules: [rules.required]
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                class: "text-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn, {
                                    color: "blue darken-1",
                                    variant: "tonal",
                                    size: "large",
                                    class: "login-form__button",
                                    type: "submit",
                                    loading: isSubmitting.value,
                                    disabled: isSubmitting.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Enviar consulta ")
                                    ]),
                                    _: 1
                                  }, 8, ["loading", "disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 512)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(ModalSuccess, {
        isVisible: showSuccessModal.value,
        message: "Consulta enviada con exito.",
        "onUpdate:isVisible": _cache[2] || (_cache[2] = ($event: any) => (showSuccessModal.value = $event))
      }, null, 8, ["isVisible"]),
      _createVNode(ModalError, {
        isVisible: showErrorModal.value,
        message: "No se ha podido enviar la consulta. Contacta con el administrador.",
        "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => (showErrorModal.value = $event))
      }, null, 8, ["isVisible"])
    ]),
    _: 1
  }))
}
}

})